import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "submitButton"];

  connect() {
    this.toggleSubmitButton();
  }

  // Action method to handle the focus event
  scrollToBottom() {
    // A slight delay can sometimes help ensure the virtual keyboard has started appearing
    setTimeout(() => {
      this.submitButtonTarget.scrollIntoView({
        behavior: "smooth",
        block: "end", // Aligns the end (bottom) of the element to the end of the viewport
      });
    }, 100); // 100ms delay
  }

  toggleSubmitButton() {
    const allInputsFilled = this.inputTargets.every(
      (input) => input.value.length === input.maxLength,
    );

    if (allInputsFilled) {
      setTimeout(() => {
        this.submitButtonTarget.disabled = false;
      }, 300);
    } else {
      this.submitButtonTarget.disabled = true;
    }
  }

  moveToNext(event) {
    const currentInput = event.target;
    const maxLength = currentInput.maxLength;
    const currentLength = currentInput.value.length;

    if (maxLength && currentLength >= maxLength) {
      const currentIndex = this.inputTargets.indexOf(currentInput);
      const nextInput = this.inputTargets[currentIndex + 1];

      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  handlePaste(event) {
    // Prevent the default paste behavior (which would only fill the first input)
    event.preventDefault();

    // Get the pasted text from the clipboard data
    const paste = event.clipboardData.getData("text");

    // Sanitize the input (e.g., keep only digits if that's what you expect)
    const sanitizedPaste = paste
      .replace(/\s|-/g, "")
      .substring(0, this.inputTargets.length);
    const chars = [...sanitizedPaste]; // Split into an array of characters

    // Determine the starting index (useful if pasting into a later box)
    const startIndex = this.inputTargets.indexOf(event.target);

    // Distribute the characters across the inputs starting from the current one
    chars.forEach((char, index) => {
      const inputIndex = startIndex + index;
      if (inputIndex < this.inputTargets.length) {
        this.inputTargets[inputIndex].value = char;
      }
    });

    // Manually trigger the toggle logic and move focus, as the 'input' event might not fire perfectly across all inputs
    this.toggleSubmitButton();

    // Focus on the next logical input after pasting (e.g., the last filled one or the one after that)
    const nextFocusIndex = Math.min(
      this.inputTargets.length - 1,
      startIndex + chars.length,
    );
    this.inputTargets[nextFocusIndex].focus();
  }
}
